cv.mixins.PaginateModel = {
  defaultParams: {
    filters: [],
    term: "",
    offset: 0,
    limit: 20,
    order: "",
  },

  params: {},

  initialize: function (models, options) {
    // We have to explicitely set the parameters to default because any leftover params that aren't specified
    // will still be there when we create a new Model such as project_id, team_id, etc.
    // Have to clone the property or there will be a reference to it
    this.params = _.clone(this.defaultParams);

    // If we have some incoming parameters that are larger than 0 we override it
    if (!_.isUndefined(options) && _.has(options, "params") && _.size(options.params) > 0) {
      this.params = _.extend(this.params, options.params);
    }

    // Some logging
    this.on(
      "request",
      function (model, xhr) {
        console.log("Fetching collection...");
      },
      this
    );

    // Set the synced flag to true
    this.on(
      "sync",
      function (model, xhr) {
        // console.groupEnd();
      },
      this
    );

    console.log("PaginateModel mixin loaded.");
  },

  previousPage: function () {
    if (this.params.offset - this.params.limit >= 0) {
      this.params.offset = this.params.offset - this.params.limit;
    }
    this.fetch({
      reset: true,
    });
  },

  nextPage: function () {
    if (this.params.offset + this.params.limit < this.num_records) {
      this.params.offset = this.params.offset + this.params.limit;
    }
    this.fetch({
      reset: true,
    });
  },

  next20: function () {
    this.params.offset = this.params.offset + this.params.limit;
    this.fetch({ add: true, remove: false });
  },

  parse: function (response) {
    // These are global values that are returned and not passed back
    if (!_.isUndefined(response.num_records)) {
      this.num_records = parseInt(response.num_records, 10);
    } else {
      this.num_records = parseInt(response.total_count, 10);
    }
    this.params.filters = response.filters;
    this.params.order = response.order;

    // Convert back to integers
    this.params.offset = parseInt(this.params.offset, 10);
    this.params.limit = parseInt(this.params.limit, 10);

    if (this.params.offset + this.params.limit < this.num_records) {
      this.caption =
        this.params.offset +
        1 +
        " - " +
        (this.params.offset + this.params.limit) +
        " of " +
        this.num_records;
    } else {
      this.caption = this.params.offset + 1 + " - " + this.num_records + " of " + this.num_records;
    }

    // This offset is passed back from the response
    this.params.offset = parseInt(response.offset, 10);

    return response.data;
  },
};
